import React from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Card,
  Container,
  Row,
  Col,
  Button,
  Input,
  Label,
  FormGroup,
  Form,
  FormFeedback,
  Table,
} from "reactstrap"

import { get } from "../../../helpers/api_helper"

import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation, useParams } from "react-router-dom"
import LoadingComponent from "components/Loading/LoadingComponent"
import { useFormik } from "formik"
import * as Yup from "yup"
import { MetaTags } from "react-meta-tags"
import Select from "react-select"
import FabricOrderAction from "store/fabric-order-resource/actions"
import { getFabricTradingListResource } from "store/actions"
import DatePicker from "react-flatpickr"
import ScrollBar from "react-perfect-scrollbar"
import SelectOrderNumber from "./components/SelectOrderNumber"
import SelectCustomerName from "./components/SelectCustomerName"
import SelectBrand from "./components/SelectBrand"
import SelectBunch from "./components/SelectBunch"
import SelectFabricNumber from "./components/SelectFabricNumber"
import ReadOnlyInput from "./components/ReadOnlyInput"
import moment from "moment"
import Skeleton from "react-loading-skeleton"
import TableContainer from "components/tables/TableContainer"

export default function DetailFabricPurchaseManagement() {
  const dispatch = useDispatch()
  const params = useParams()
  const history = useHistory()
  const location = useLocation()
  const store = useSelector(state => state)

  const edit = React.useMemo(() => {
    return params.id != "add"
  }, [params.id])

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      orderDate: "",
      orderNumber: "",
      tradingCompanyId: "",
      tradingCompanyName: "",
      details: [
        {
          orderId: "",
          orderNumber: "",
          order: "",
          customerId: "",
          companyName: "",
          fabricId: "",
          numberOfOrders: "",
          numberOfDelivered: "",
          unitPrice: "",
          activeColumn: "",
          isIgarashi: false,
          numberOfDeliveries: "",
          deliveryDate: "",
        },
      ],
    },
    validationSchema: Yup.object({
      orderDate: Yup.date().required("必須項目です。"),
      tradingCompanyId: Yup.number().when(() => {
        if (!edit) return Yup.number().required("必須項目です。")
      }),
      tradingCompanyName: Yup.string(),
      details: Yup.array()
        .of(
          Yup.object({
            numberOfOrders: Yup.number().when(
              ["orderId", "companyName"],
              (orderId, companyName) => {
                if (orderId || companyName)
                  return Yup.number().required("必須項目です。")
              }
            ),
            deliveryDate: Yup.date(),
            numberOfDeliveries: Yup.number().when(
              ["numberOfOrders", "numberOfDelivered"],
              (numberOfOrders, numberOfDelivered) => {
                return Yup.number()
                  .min(0)
                  .max(
                    numberOfOrders - numberOfDelivered,
                    `${
                      numberOfOrders - numberOfDelivered
                    }未満である必須項目です。があります`
                  )
              }
            ),
          })
        )
        .min(1)
        .required("必須項目です。"),
    }),
    onSubmit: values => {
      if (params.id === "add") {
        const detailsPayload = values.details
          .filter(j => j.orderId || j.companyName)
          .map(i => {
            if (i.orderId) {
              return {
                orderId: i.orderId,
                order: i.order,
                numberOfOrders: i.numberOfOrders,
                total: i.unitPrice * i.numberOfOrders,
                unitPrice: i.unitPrice,
              }
            } else {
              return {
                companyName: i.companyName,
                fabricId: i.fabricId,
                numberOfOrders: i.numberOfOrders,
                total: i.unitPrice * i.numberOfOrders,
                unitPrice: i.unitPrice,
              }
            }
          })

        const payload = {
          orderDate: moment(values.orderDate).format("YYYY-MM-DD"),
          tradingCompanyId: values.tradingCompanyId,
          details: detailsPayload,
        }
        dispatch(FabricOrderAction.postData(payload, callbackPost))
      } else {
        const details = values.details.map(i => ({
          id: i.id,
          numberOfDeliveries: i.numberOfDeliveries,
          deliveryDate: moment(i.deliveryDate).format("YYYY-MM-DD"),
        }))

        const payload = {
          details,
        }

        dispatch(
          FabricOrderAction.putData({ ...payload, id: params.id }, callbackPut)
        )
      }
    },
  })

  const columns = React.useMemo(
    () => [
      {
        Header: "日付",
        accessor: "historyDate",
        defaultCanSort: false,
      },
      {
        Header: "履歴",
        accessor: "history",
        defaultCanSort: false,
      },
    ],
    []
  )

  const callbackPost = () => {
    history.push("/inventory-control/fabric-purchase-management/")
    validation.resetForm()
  }

  const callbackPut = () => {
    history.push("/inventory-control/fabric-purchase-management/")
    validation.resetForm()
  }

  const callbackGetDetail = data => {
    console.log("data")
    console.log(data.details)
    validation.setValues(data)
  }

  React.useEffect(() => {
    if (params.id !== "add") {
      dispatch(
        FabricOrderAction.getDetail({ id: params.id }, callbackGetDetail)
      )
    }
    if (location.state?.data) {
      location.state?.data.forEach(l => {
        l.numberOfOrders = l.scale
      })
      validation.setFieldValue(
        "tradingCompanyId",
        location.state.data[0].fabricTradingCompanyId
      )
      validation.setFieldValue("details", location.state.data)
      detailsOptions(location.state.data[0].fabricTradingCompanyId)
      validation.setFieldValue("orderDate", new Date())
    } else {
      validation.setFieldValue("orderDate", new Date())
    }
  }, [params.id])

  React.useEffect(() => {}, [location.state?.data])

  React.useEffect(() => {
    dispatch(getFabricTradingListResource())
  }, [])

  const detailsOptions = id => {
    dispatch(FabricOrderAction.getList({ id }))
    dispatch(FabricOrderAction.getListCustomer({ id }))
    dispatch(FabricOrderAction.getListBrand({ id }))
  }

  const addDetails = index => {
    if (!validation.values.details[index + 1]) {
      validation.setFieldValue(`details.${index + 1}.orderId`, "")
      validation.setFieldValue(`details.${index + 1}.orderNumber`, "")
      validation.setFieldValue(`details.${index + 1}.order`, "")
      validation.setFieldValue(`details.${index + 1}.customerId`, "")
      validation.setFieldValue(`details.${index + 1}.fabricId`, "")
      validation.setFieldValue(`details.${index + 1}.numberOfOrders`, "")
      validation.setFieldValue(`details.${index + 1}.unitPrice`, "")
    }
  }

  const onChangeTradingCompany = e => {
    validation.setFieldValue("tradingCompanyId", e.value)
    validation.setFieldValue("tradingCompanyName", e.label)
    detailsOptions(e.value)
  }

  const exportXlsx = async () => {
    const { data } = await get(`admin/fabric-order/${params.id}/print`, "", {
      responseType: "arraybuffer",
    })
    const file = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })

    // process to auto download it
    const fileURL = URL.createObjectURL(file)
    const link = document.createElement("a")
    link.href = fileURL
    link.download = `fabric-purchase-management.xlsx`
    link.click()
  }
  return (
    <>
      <MetaTags>
        <title>新規発注 | Igarashi Trousers</title>
      </MetaTags>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="生地仕入管理" breadcrumbList={[]} />

          <Card body>
            {store.rtwProduct.detail.loading ? (
              <LoadingComponent />
            ) : (
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Row>
                  <Col md="8">
                    {params.id !== "add"
                      ? "生地仕入管理詳細"
                      : "新規生地仕入管理追加"}
                  </Col>
                </Row>
                <Row>
                  <Col sm="12" className="text-end">
                    {params.id !== "add" && (
                      <Button
                        type="button"
                        className="me-2 button"
                        onClick={() => exportXlsx()}
                      >
                        印刷する
                      </Button>
                    )}

                    {store.fabricOrder.saved.loading ? (
                      <Skeleton width={50} height={30} />
                    ) : (
                      <Button type="submit" className="button">
                        保存
                      </Button>
                    )}

                    <Button
                      type="button"
                      className="ms-2 button"
                      onClick={() =>
                        history.push(
                          "/inventory-control/fabric-purchase-management"
                        )
                      }
                    >
                      キャンセル
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <FormGroup row>
                      <Label sm="2">生地商社名</Label>
                      <Col sm="6" xl="3">
                        <Select
                          isLoading={!store.fabricTreding.dataForList.length}
                          isDisabled={edit}
                          options={store.fabricTreding.dataForList.map(i => ({
                            value: i.id,
                            label: i.name,
                          }))}
                          // defaultValue={{
                          //   value: validation.values.tradingCompanyId,
                          //   label: store.fabricTreding.dataForList.find(
                          //     i => i.id == validation.values.tradingCompanyId
                          //   )?.name,
                          // }}
                          value={{
                            value:
                              params.id !== "add"
                                ? validation.values.tradingCompanyName
                                : validation.values.tradingCompanyId,
                            label:
                              params.id !== "add"
                                ? store.fabricTreding.dataForList.find(
                                    i =>
                                      i.name ==
                                      validation.values.tradingCompanyName
                                  )?.name
                                : store.fabricTreding.dataForList.find(
                                    i =>
                                      i.id == validation.values.tradingCompanyId
                                  )?.name,
                          }}
                          onChange={onChangeTradingCompany}
                        />
                        <Input
                          name="tradingCompanyId"
                          className="form-control d-none"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.tradingCompanyId || ""}
                          invalid={
                            validation.touched.tradingCompanyId &&
                            validation.errors.tradingCompanyId
                              ? true
                              : false
                          }
                        />
                        {validation.touched.tradingCompanyId &&
                        validation.errors.tradingCompanyId ? (
                          <FormFeedback type="invalid">
                            {validation.errors.tradingCompanyId}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </FormGroup>

                    <FormGroup row>
                      <Label sm="2">日付</Label>
                      <Col sm="6" xl="3">
                        <DatePicker
                          disabled={edit}
                          name="orderDate"
                          className="form-control"
                          type="text"
                          onChange={date => {
                            validation.setFieldValue("orderDate", date[0])
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.orderDate || ""}
                          invalid={
                            validation.touched.orderDate &&
                            validation.errors.orderDate
                              ? true
                              : false
                          }
                        />
                        <Input
                          name="orderDate"
                          className="form-control d-none"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.orderDate || ""}
                          invalid={
                            validation.touched.orderDate &&
                            validation.errors.orderDate
                              ? true
                              : false
                          }
                        />
                        {validation.touched.orderDate &&
                        validation.errors.orderDate ? (
                          <FormFeedback type="invalid">
                            {validation.errors.orderDate}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </FormGroup>
                    {edit && (
                      <FormGroup row>
                        <Label sm="2">生地発注番号</Label>
                        <Col sm="3">
                          <Input
                            disabled
                            name="orderDate"
                            className="form-control"
                            type="text"
                            value={validation.values.orderNumber || ""}
                          />
                        </Col>
                      </FormGroup>
                    )}
                  </Col>
                  <Col
                    sm="12"
                    className={`${
                      !validation.values.tradingCompanyId &&
                      !validation.values.tradingCompanyName
                        ? "d-none"
                        : ""
                    }`}
                  >
                    <ScrollBar style={{ position: "relative" }}>
                      <div style={{ width: edit ? 2000 : 1500 }}>
                        <Row>
                          <Col md="12">
                            <div>
                              <Table bordered>
                                <thead>
                                  <tr>
                                    <td style={{ width: 200 }}>受注ID</td>
                                    <td style={{ width: 200 }}>名前</td>
                                    <td style={{ width: 200 }}>ブランド</td>
                                    <td style={{ width: 200 }}>バンチ</td>
                                    <td style={{ width: 200 }}>
                                      生地番号・商品コード
                                    </td>
                                    <td style={{ width: 200 }}>発注数（m）</td>
                                    <td style={{ width: 200 }}>単価</td>
                                    <td style={{ width: 200 }}>合計</td>
                                    {!edit && <td></td>}
                                    {edit && (
                                      <td style={{ width: 200 }}>納品済数</td>
                                    )}
                                    {edit && (
                                      <td style={{ width: 200 }}>納品数</td>
                                    )}
                                    {edit && (
                                      <td style={{ width: 200 }}>納品日</td>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  {validation?.values?.details.map((i, k) => (
                                    <tr key={k}>
                                      <td>
                                        <SelectOrderNumber
                                          validation={validation}
                                          detail={i}
                                          detailIndex={k}
                                          edit={edit}
                                          addDetails={addDetails}
                                        />
                                      </td>
                                      <td>
                                        <SelectCustomerName
                                          validation={validation}
                                          detail={i}
                                          detailIndex={k}
                                          edit={edit}
                                          addDetails={addDetails}
                                        />
                                      </td>
                                      <td>
                                        <SelectBrand
                                          validation={validation}
                                          detail={i}
                                          detailIndex={k}
                                          edit={edit}
                                        />
                                      </td>
                                      <td>
                                        <SelectBunch
                                          validation={validation}
                                          detail={i}
                                          detailIndex={k}
                                          edit={edit}
                                        />
                                      </td>
                                      <td>
                                        <SelectFabricNumber
                                          validation={validation}
                                          detail={i}
                                          detailIndex={k}
                                          edit={edit}
                                        />
                                      </td>
                                      <td>
                                        <Input
                                          name={`details[${k}].numberOfOrders`}
                                          className="form-control"
                                          disabled={edit}
                                          type="text"
                                          onChange={validation.handleChange}
                                          onBlur={validation.handleBlur}
                                          value={i.numberOfOrders || ""}
                                          invalid={
                                            validation.touched?.details &&
                                            validation.errors?.details
                                              ? validation.touched?.details[k]
                                                  ?.numberOfOrders &&
                                                validation.errors?.details[k]
                                                  ?.numberOfOrders
                                                ? true
                                                : false
                                              : false
                                          }
                                        />
                                        {validation.touched?.details &&
                                        validation.errors?.details ? (
                                          <FormFeedback type="invalid">
                                            {
                                              validation.errors?.details[k]
                                                ?.numberOfOrders
                                            }
                                          </FormFeedback>
                                        ) : null}
                                      </td>
                                      <td>
                                        <ReadOnlyInput
                                          value={i.unitPrice.toLocaleString(
                                            "ja-JP"
                                          )}
                                        />
                                      </td>
                                      <td>
                                        <ReadOnlyInput
                                          value={(
                                            i.unitPrice * i.numberOfOrders
                                          ).toLocaleString("ja-JP")}
                                        />
                                      </td>
                                      {!edit && (
                                        <td>
                                          {validation.values.details.length >
                                            1 && (
                                            <div
                                              role="button"
                                              className="text-danger  d-flex align-items-center justify-content-center"
                                            >
                                              <span
                                                onClick={() => {
                                                  const current = [
                                                    ...validation.values
                                                      .details,
                                                  ]
                                                  current.splice(k, 1)
                                                  validation.setFieldValue(
                                                    "details",
                                                    current
                                                  )
                                                }}
                                              >
                                                x
                                              </span>
                                            </div>
                                          )}
                                        </td>
                                      )}

                                      {edit && (
                                        <td>
                                          <Input
                                            name={`details[${k}].numberOfDelivered`}
                                            className="form-control"
                                            disabled
                                            type="text"
                                            value={i.numberOfDelivered || ""}
                                          />
                                        </td>
                                      )}

                                      {edit && (
                                        <td>
                                          <Input
                                            name={`details[${k}].numberOfDeliveries`}
                                            className="form-control"
                                            disabled={
                                              i.numberOfDelivered ==
                                              i.numberOfOrders
                                            }
                                            type="text"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={i.numberOfDeliveries || ""}
                                            invalid={
                                              validation.touched?.details &&
                                              validation.errors?.details
                                                ? validation.touched?.details[k]
                                                    ?.numberOfDeliveries &&
                                                  validation.errors?.details[k]
                                                    ?.numberOfDeliveries
                                                  ? true
                                                  : false
                                                : false
                                            }
                                          />
                                          {validation.touched?.details &&
                                          validation.errors?.details ? (
                                            <FormFeedback type="invalid">
                                              {
                                                validation.errors?.details[k]
                                                  ?.numberOfDeliveries
                                              }
                                            </FormFeedback>
                                          ) : null}
                                        </td>
                                      )}

                                      {edit && (
                                        <td>
                                          <DatePicker
                                            name={`details[${k}].deliveryDate`}
                                            className="form-control"
                                            type="text"
                                            disabled={
                                              i.numberOfDelivered ==
                                              i.numberOfOrders
                                            }
                                            onChange={date => {
                                              validation.setFieldValue(
                                                `details.${k}.deliveryDate`,
                                                date[0]
                                              )
                                            }}
                                            onBlur={validation.handleBlur}
                                            value={i.deliveryDate}
                                          />
                                          <Input
                                            name={`details[${k}].deliveryDate`}
                                            className="form-control d-none"
                                            type="text"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={i.deliveryDate || ""}
                                            invalid={
                                              validation.touched?.details &&
                                              validation.errors?.details
                                                ? validation.touched?.details[k]
                                                    ?.deliveryDate &&
                                                  validation.errors?.details[k]
                                                    ?.deliveryDate
                                                  ? true
                                                  : false
                                                : false
                                            }
                                          />
                                          {validation.touched?.details &&
                                          validation.errors?.details ? (
                                            <FormFeedback type="invalid">
                                              {
                                                validation.errors?.details[k]
                                                  ?.deliveryDate
                                              }
                                            </FormFeedback>
                                          ) : null}
                                        </td>
                                      )}
                                    </tr>
                                  ))}
                                  <TotalPriceOrder
                                    validation={validation}
                                    edit={edit}
                                  />
                                </tbody>
                              </Table>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </ScrollBar>
                  </Col>
                </Row>
              </Form>
            )}
          </Card>

          {edit && (
            <Card body style={{ overflow: "scroll" }}>
              {store.fabricOrder.detail.loading ? (
                <LoadingComponent />
              ) : (
                <TableContainer
                  data={store.fabricOrder.detail.data?.histories || []}
                  columns={columns}
                  // pagination
                  // page={params.page}
                  // size={params.size}
                  // count={store.fabricOrder.detail.data?.history.length || 1}
                />
              )}
            </Card>
          )}
        </Container>
      </div>
    </>
  )
}

const TotalPriceOrder = ({ validation, edit }) => {
  return (
    <tr>
      <td />
      <td />
      <td />
      <td />
      <td />
      <td />
      <td>総合計</td>
      <td>
        {validation.values.details
          .map(i => i.unitPrice * i.numberOfOrders)
          .reduce((a, b) => a + b, 0)
          .toLocaleString("ja-JP")}
      </td>
      {!edit && <td />}

      {edit && (
        <>
          <td />
          <td />
          <td />
        </>
      )}
    </tr>
  )
}
